import { useEffect, useState } from "react"
import Table from "../Table"
import MyModal from "../MyModal"
import { AiOutlineDelete, AiOutlineEdit } from "react-icons/ai"
import actionHelper from "../../lib/actionHelper"
import { toast } from "react-toastify"
import Input from "../Input"
import { addRadio, deleteRadio, editRadio, getRadioList } from "../../services/radioApis"
import { deleteToken, genToken, getTokenList } from "../../services/userApis"
import { CopyOutlined } from "@ant-design/icons"
import getTimeDiffFaString from "../../utils/getTimeDiffFaString"
import getTimeDiffInDays from "../../utils/getTimeDiffInDays"

const cols = [
    {
        name: "کاربر",
        colSpan: 1,
    },
    {
        name: "توکن",
        colSpan: 1,
    },

    {
        name: "تاریخ انقضا",
        colSpan: 1,
    },
    {
        name: "",
        colSpan: 1,
    },
]

const EditTokenModal = ({ token }) => {
    const [isOpen, setIsOpen] = useState(false)
    const toggleModal = () => setIsOpen(!isOpen)

    // const submitHandler = (e) => {
    //     e.preventDefault()
    //     const form = new FormData(e.target)

    //     const data = {
    //         radioId: radio.id,
    //         name: form.get("radio-name"),
    //         url: form.get("radio-url"),
    //         information: form.get("information") == "" ? null : form.get("information"),
    //     }
    //     toast
    //         .promise(editRadio(data), {
    //             pending: "درحال ویرایش",
    //             success: "ویرایش شد",
    //         })
    //         .catch((err) => {
    //             console.error(err)
    //         })
    // }

    // return (
    //     <>
    //         <button
    //             onClick={toggleModal}
    //             className="flex rounded-md m-2 select-none focus:outline-none focus:shadow-outline"
    //         >
    //             <AiOutlineEdit size="1.7em" className=" hover:fill-yellow-400" />
    //         </button>
    //         <MyModal width="400px" height="300px" isOpen={isOpen} toggleModal={toggleModal}>
    //             <form className="mt-5" onSubmit={submitHandler}>
    //                 <div>
    //                     <Input
    //                         label="نام رادیو"
    //                         type="text"
    //                         name="radio-name"
    //                         placeholder="نام"
    //                         required={true}
    //                         defaultValue={radio.name}
    //                     />
    //                 </div>
    //                 <div>
    //                     <Input
    //                         label="لینک"
    //                         type="text"
    //                         name="radio-url"
    //                         placeholder="Url"
    //                         required={true}
    //                         defaultValue={radio.url}
    //                     />
    //                 </div>

    //                 <div>
    //                     <Input
    //                         label="توضیحات"
    //                         name="information"
    //                         placeholder="توضیحات"
    //                         defaultValue={radio.information}
    //                         required={true}
    //                     />
    //                 </div>

    //                 <button type="submit" className="mt-5 w-full styled-button border">
    //                     ویرایش رادیو
    //                 </button>
    //             </form>
    //         </MyModal>
    //     </>
    // )
}

const CreateTokenModal = () => {
    const [isOpen, setIsOpen] = useState(false)

    const toggleModal = () => {
        setIsOpen(!isOpen)
    }

    const submitHandler = (e) => {
        e.preventDefault()
        const form = new FormData(e.target)

        const data = {
            timeInDays: form.get("timeInDays"),
        }

        toast
            .promise(genToken(data), {
                pending: "درحال ساخت ",
                success: "ساخته شد",
            })
            .then(({ data }) => {})
            .catch((err) => {
                console.error(err)
            })
    }

    return (
        <>
            <button onClick={toggleModal} className="flex gap-2 w-32 pl-2 styled-button mr-3 mb-3">
                <img src="assets/icons/square-plus.svg" className="h-5 w-5" />
                ساخت توکن
            </button>
            <MyModal width="400px" height="300px" isOpen={isOpen} toggleModal={toggleModal}>
                <form className="mt-5" onSubmit={submitHandler}>
                    <div>
                        <Input
                            label="مدت زمان توکن (به روز)"
                            type="number"
                            name="timeInDays"
                            placeholder="Token Expires In"
                            required={false}
                        />
                    </div>

                    <button type="submit" className="mt-5 w-full styled-button border">
                        ساخت توکن
                    </button>
                </form>
            </MyModal>
        </>
    )
}

const GenerateToken = ({ user }) => {
    const [tokenList, setTokenList] = useState(null)
    const updateUi = () => {
        if (user) {
            getTokenList()
                .then(({ data }) => {
                    data = data.map((token) => {
                        const expireDate = new Date(token.expiresAt)
                        const now = new Date()

                        const expiresInDays = token.expiresAt == null ? null : getTimeDiffInDays(expireDate, now)
                        console.log(expiresInDays)
                        const expString = getTimeDiffFaString(expireDate, now)
                        console.log(token)
                        let obj = {
                            name: token.user,
                            url: "..." + token.token.slice(0, 30),
                            expString:
                                token.expiresAt != null ? (
                                    <span className={expiresInDays > 0 ? "text-success" : "text-danger"}>
                                        {expString}
                                    </span>
                                ) : (
                                    <span>دائمی</span>
                                ),
                            more: (
                                <div className="flex gap-3 justify-end">
                                    <button
                                        onClick={() => {
                                            toast.promise(deleteToken(token.tokenId), {
                                                success: "حذف شد",
                                                pending: "درحال حذف",
                                            })
                                        }}
                                        className="flex rounded-md m-2 select-none focus:outline-none focus:shadow-outline"
                                    >
                                        <AiOutlineDelete size="1.7em" className=" hover:fill-red-400" />
                                    </button>
                                    <button
                                        type="button"
                                        onClick={async () => {
                                            await navigator.clipboard.writeText(token.token)
                                            toast.success("کپی شد")
                                        }}
                                    >
                                        <CopyOutlined size="1.7em" />
                                    </button>
                                </div>
                            ),
                        }
                        return obj
                    })
                    setTokenList(data)
                })
                .catch((err) => {
                    console.error(err)
                })
        }
    }

    useEffect(() => {
        updateUi()
        const interval = setInterval(updateUi, 5000)
        return () => clearInterval(interval)
    }, [])

    return (
        <>
            <CreateTokenModal user={user} />
            <Table cols={cols} rows={tokenList} paging={{ maxRows: 10 }} />
        </>
    )
}

export default GenerateToken
